const psErrorsMixin = {
  methods: {
    errorMessage(errorName) {
      const mapping = {
        'Product not sellable': 'Product not sellable',
        NoMethodError: 'Our Technical Error - needs Investigation',
        'Mongoid::Errors::Validations': 'Validation Error - needs Investigation',
        ValidationError: 'Validation Error - needs Investigation',
        NoConfigurationPartsError: 'When requesting pricing - no parts were returned',
        TypeError: 'Our Technical Error - needs Investigation',
        NoFobPointsAssigned: "Could not find a fob point from supplier's data",
        ProductDataRequestError:
          "Error happened when making requests to 'Product Data' endpoint. Need to ask Supplier.",
        NoPartsError: 'Product Data returned no parts',
        StatusCodeError: 'Network error',
        NoShippingPackagesError: "Supplier didn't provided shipping package info",
        'Timeout::Error': 'Took too long for supplier to respond',
        Error: 'Our Technical Error - needs Investigation',
        NoLocationsError: "Product doesn't have locations. Shouldn't be an error"
      };

      return mapping[errorName] || 'Probably Out Technical Internal Error';
    }
  }
};

export { psErrorsMixin as default };
